// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Map from "melange/map.js";
import * as Stdlib__String from "melange/string.js";

const Items = Stdlib__Map.Make({
  compare: Stdlib__String.compare
});

function scope_name(param) {
  switch (param) {
    case /* Read */ 0 :
      return "read";
    case /* Execute */ 1 :
      return "execute";
    case /* Publish */ 2 :
      return "publish";
    case /* Edit_environment */ 3 :
      return "edit_environment";
    case /* Admin */ 4 :
      return "admin";
  }
}

function initial(request_id) {
  return {
    items: /* [] */ 0,
    cursor: undefined,
    name: "",
    days: "30",
    scopes: {
      hd: /* Read */ 0,
      tl: /* [] */ 0
    },
    project_only: false,
    request_id,
    claim: undefined,
    secret: undefined,
    issued: false,
    loading: true,
    pending: false,
    message: ""
  };
}

function decode(json) {
  const n = Js__Js_json.decodeNumber(Mapre_wire__Json.get(json, "expires_at"));
  let tmp;
  if (n !== undefined) {
    if (Stdlib__Float.is_finite(n)) {
      tmp = n;
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_token_expiry"
        });
    }
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_token_expiry"
      });
  }
  return {
    id: Mapre_wire__Json.string(json, "id"),
    name: Mapre_wire__Json.string(json, "name"),
    prefix: Mapre_wire__Json.string(json, "display_prefix"),
    workspace: Mapre_wire__Json.string(json, "workspace_id"),
    project: Js__Js_json.decodeString(Mapre_wire__Json.get(json, "project_id")),
    scopes: Stdlib__Array.to_list(Stdlib__Array.map((function (value) {
      const s = Js__Js_json.decodeString(value);
      if (s !== undefined) {
        return s;
      }
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_token_scope"
        });
    }), Mapre_wire__Json.array(json, "scopes"))),
    expires_at: tmp,
    revoked: Caml_obj.caml_notequal(Mapre_wire__Json.get(json, "revoked_at"), null)
  };
}

function merge(items, incoming) {
  return Stdlib__List.map((function (prim) {
    return prim[1];
  }), Curry._1(Items.bindings, Stdlib__List.fold_left((function (map, item) {
    return Curry._3(Items.add, item.id, item, map);
  }), Items.empty, Stdlib__List.rev_append(items, incoming))));
}

function days(value) {
  if (value === "" || !Stdlib__String.for_all((function (param) {
      return !(param > 57 || param < 48);
    }), value)) {
    return;
  }
  const n = Stdlib.int_of_string_opt(value);
  if (n !== undefined && n >= 1 && n <= 365) {
    return n;
  }
  
}

function editable(t) {
  if (!t.pending && !t.loading && t.claim === undefined) {
    return !t.issued;
  } else {
    return false;
  }
}

function valid_name(name) {
  if (Stdlib__String.trim(name) !== "" && Mapre_web__Browser.utf8_size(name) <= 120) {
    return Stdlib__String.for_all((function (c) {
      if (c >= 32) {
        return c !== 127;
      } else {
        return false;
      }
    }), name);
  } else {
    return false;
  }
}

function can_submit(t) {
  if (!t.loading && !t.pending && !t.issued) {
    if (t.claim !== undefined) {
      return true;
    } else if (valid_name(t.name) && days(t.days) !== undefined) {
      return Caml_obj.caml_notequal(t.scopes, /* [] */ 0);
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function update(t, request_id) {
  if (/* tag */ typeof request_id !== "object" && typeof request_id !== "function") {
    switch (request_id) {
      case /* Pending */ 6 :
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: undefined,
          issued: t.issued,
          loading: t.loading,
          pending: true,
          message: ""
        };
      case /* Loading */ 7 :
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: undefined,
          issued: t.issued,
          loading: true,
          pending: t.pending,
          message: t.message
        };
      case /* Secret_lost */ 8 :
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: undefined,
          issued: true,
          loading: t.loading,
          pending: false,
          message: "This token was created, but its secret could not be recovered. Revoke it and explicitly create a new token."
        };
    }
  } else {
    switch (request_id.TAG) {
      case /* New */ 1 :
        const init = initial(request_id._0);
        return {
          items: t.items,
          cursor: t.cursor,
          name: init.name,
          days: init.days,
          scopes: init.scopes,
          project_only: init.project_only,
          request_id: init.request_id,
          claim: init.claim,
          secret: init.secret,
          issued: init.issued,
          loading: false,
          pending: init.pending,
          message: init.message
        };
      case /* Claim */ 4 :
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: request_id._0,
          secret: undefined,
          issued: t.issued,
          loading: t.loading,
          pending: true,
          message: ""
        };
      case /* Loaded */ 5 :
        const items = request_id._0;
        return {
          items: request_id._2 ? merge(t.items, items) : items,
          cursor: request_id._1,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: t.secret,
          issued: t.issued,
          loading: false,
          pending: false,
          message: t.message
        };
      case /* Created */ 6 :
        return {
          items: merge(t.items, {
            hd: request_id._0,
            tl: /* [] */ 0
          }),
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: request_id._1,
          issued: true,
          loading: t.loading,
          pending: false,
          message: "Copy this token now. It will not be shown again."
        };
      case /* Revoked */ 8 :
        return {
          items: merge(t.items, {
            hd: request_id._0,
            tl: /* [] */ 0
          }),
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: undefined,
          issued: t.issued,
          loading: t.loading,
          pending: false,
          message: "Token revoked."
        };
      case /* Failed */ 9 :
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: undefined,
          issued: t.issued,
          loading: false,
          pending: false,
          message: request_id._0
        };
    }
  }
  if (editable(t)) {
    if (/* tag */ typeof request_id !== "object" && typeof request_id !== "function") {
      if (request_id === /* Toggle_project */ 4) {
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: t.scopes,
          project_only: !t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: t.secret,
          issued: t.issued,
          loading: t.loading,
          pending: t.pending,
          message: t.message
        };
      } else {
        return t;
      }
    }
    switch (request_id.TAG) {
      case /* Edit */ 2 :
        if (request_id._0 === /* Name */ 0) {
          return {
            items: t.items,
            cursor: t.cursor,
            name: request_id._1,
            days: t.days,
            scopes: t.scopes,
            project_only: t.project_only,
            request_id: t.request_id,
            claim: t.claim,
            secret: t.secret,
            issued: t.issued,
            loading: t.loading,
            pending: t.pending,
            message: ""
          };
        } else {
          return {
            items: t.items,
            cursor: t.cursor,
            name: t.name,
            days: request_id._1,
            scopes: t.scopes,
            project_only: t.project_only,
            request_id: t.request_id,
            claim: t.claim,
            secret: t.secret,
            issued: t.issued,
            loading: t.loading,
            pending: t.pending,
            message: ""
          };
        }
      case /* Toggle_scope */ 3 :
        const scope = request_id._0;
        return {
          items: t.items,
          cursor: t.cursor,
          name: t.name,
          days: t.days,
          scopes: Stdlib__List.mem(scope, t.scopes) ? Stdlib__List.filter((function (param) {
              return scope !== param;
            }), t.scopes) : ({
              hd: scope,
              tl: t.scopes
            }),
          project_only: t.project_only,
          request_id: t.request_id,
          claim: t.claim,
          secret: t.secret,
          issued: t.issued,
          loading: t.loading,
          pending: t.pending,
          message: t.message
        };
      default:
        return t;
    }
  } else {
    return t;
  }
}

export {
  initial,
  scope_name,
  decode,
  update,
  days,
  editable,
  can_submit,
}
/* Items Not a pure module */
